import { useState } from "react";
import { FaUserGraduate, FaMicrophone, FaAward } from "react-icons/fa";

const ICONS = {
  coaching: FaUserGraduate,
  speech: FaMicrophone,
  experience: FaAward,
};

function FounderPortrait({ name, image, imageAlt, variant }) {
  const [imageError, setImageError] = useState(false);
  const isCandidat = variant === "candidat";
  const initials = name
    .split(" ")
    .map((part) => part[0])
    .join("")
    .slice(0, 2);

  if (image && !imageError) {
    return (
      <div className="relative mx-auto w-full max-w-sm">
        <div
          className={`absolute -inset-1 rounded-2xl blur opacity-40 ${
            isCandidat
              ? "bg-gradient-to-br from-brand-primary to-brand-accent1"
              : "bg-gradient-to-br from-brand-primaryDark to-brand-accent2"
          }`}
          aria-hidden
        />
        <img
          src={image}
          alt={imageAlt}
          width={1023}
          height={1537}
          className="relative w-full h-auto rounded-2xl shadow-lg"
          onError={() => setImageError(true)}
        />
      </div>
    );
  }

  return (
    <div
      className={`mx-auto w-full max-w-sm aspect-[1023/1537] rounded-2xl flex items-center justify-center shadow-lg ${
        isCandidat
          ? "bg-gradient-to-br from-brand-primary to-brand-accent1"
          : "bg-gradient-to-br from-brand-primaryDark to-brand-accent2"
      }`}
      aria-hidden
    >
      <span className="text-6xl font-bold text-white/90">{initials}</span>
    </div>
  );
}

export default function FounderSection({
  title,
  subtitle,
  name,
  role,
  image,
  imageAlt,
  bio,
  pillars = [],
  variant = "candidat",
}) {
  const isCandidat = variant === "candidat";

  return (
    <div className="container mx-auto max-w-5xl">
      <h2 className="text-2xl sm:text-3xl font-bold text-center mb-3 text-gray-900">
        {title}
      </h2>
      <p className="text-center text-gray-600 max-w-2xl mx-auto mb-10 leading-relaxed">
        {subtitle}
      </p>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center mb-12">
        <FounderPortrait
          name={name}
          image={image}
          imageAlt={imageAlt}
          variant={variant}
        />

        <div>
          <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-1">
            {name}
          </h3>
          <p
            className={`text-sm font-semibold mb-4 ${
              isCandidat ? "text-brand-primary" : "text-brand-primaryDark"
            }`}
          >
            {role}
          </p>
          <p className="text-gray-600 leading-relaxed">{bio}</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {pillars.map((pillar) => {
          const Icon = ICONS[pillar.icon] || FaUserGraduate;
          return (
            <div
              key={pillar.title}
              className={`p-6 rounded-2xl border ${
                isCandidat
                  ? "bg-gradient-to-br from-brand-primary/5 to-brand-accent1/5 border-brand-secondary/20"
                  : "bg-gradient-to-br from-brand-primaryDark/5 to-brand-accent2/5 border-brand-accent2/20"
              }`}
            >
              <div
                className={`w-10 h-10 rounded-xl flex items-center justify-center mb-3 ${
                  isCandidat
                    ? "bg-brand-primary text-white"
                    : "bg-brand-primaryDark text-white"
                }`}
              >
                <Icon className="text-lg" />
              </div>
              <h4 className="text-base font-semibold mb-2 text-gray-900">
                {pillar.title}
              </h4>
              <p className="text-gray-600 text-sm leading-relaxed">
                {pillar.description}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
